import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import LocalizationConstants from "src/app/constants/localization-constants";
import { ModalComponent, ModalService } from "src/app/services/modal.service";

export type LocalizationTranslationCreateResult = { code: string; translation: string };

@Component({
  selector: "app-localization-translation-create-modal",
  templateUrl: "./localization-translation-create-modal.component.html",
  standalone: false,
})
export class LocalizationTranslationCreateModalComponent
  implements
    ModalComponent<
      LocalizationTranslationCreateModalComponent,
      void,
      LocalizationTranslationCreateResult
    >
{
  localizationConstants = LocalizationConstants;

  constructor(
    public dialogRef: MatDialogRef<
      LocalizationTranslationCreateModalComponent,
      LocalizationTranslationCreateResult
    >,
    public modalService: ModalService,
  ) {}

  submitResult(result: LocalizationTranslationCreateResult) {
    this.dialogRef.close(result);
  }
}
